__turbopack_context__.v({
  "actions": "vzpxTW_actions",
  "root": "vzpxTW_root",
  "rootInverse": "vzpxTW_rootInverse",
  "separator": "vzpxTW_separator",
  "text": "vzpxTW_text",
  "trigger": "vzpxTW_trigger",
});
